const ClearUser = () => {
  let user = localStorage.removeItem("LogedUser")
  console.log(user);
}
export default ClearUser
